import React, { useEffect, useState } from 'react';
import HeroScreen from '../../../Views/HeroScreen';
import AnimeCard from './AnimeCard';
import SEOHead from '../../SEO/SEOHead';
import './AnimeStyle.css';

const MostPopular = () => {
    const [animeList, setAnimeList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMostPopular = async () => {
            try {
                await new Promise(r => setTimeout(r, 1500));
                const res1 = await fetch('https://api.jikan.moe/v4/top/anime?filter=bypopularity&page=1&limit=25');
                const data1 = await res1.json();
                const page1 = data1.data || [];
                setAnimeList(page1);
                setLoading(false);

                await new Promise(r => setTimeout(r, 1200));
                const res2 = await fetch('https://api.jikan.moe/v4/top/anime?filter=bypopularity&page=2&limit=25');
                const data2 = await res2.json();
                setAnimeList([...page1, ...(data2.data || [])]);
            } catch (error) {
                console.error('Error fetching popular anime:', error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchMostPopular();
    }, []);

    return (
        <div className="anime-page-most-popular">
            <SEOHead title="ChibiDash | Most Popular Anime" description="Discover the most popular anime series by community. Find trending anime on ChibiDash." path="/animehub/most-popular" />
            <HeroScreen apiUrl="https://api.jikan.moe/v4/top/anime?filter=bypopularity" />
            <h2 className="small-cards-title">Most Popular</h2>
            <p className="results-count">{animeList.length} anime found</p>
            {loading ? (
                <div className="loading-spinner-container">
                    <div className="loading-spinner"></div>
                    <p className="loading-text">Loading Popular Anime...</p>
                </div>
            ) : animeList.length > 0 ? (
                <div className="small-anime-grid">
                    {animeList.map((anime) => (
                        <AnimeCard key={anime.mal_id} anime={anime} />
                    ))}
                </div>
            ) : (
                <p className="empty-text">No popular anime found.</p>
            )}
        </div>
    );
};

export default MostPopular;
